import { isScreenBelow1004 } from 'store/common/settings/breakpoint/selectors';
import {
  FOLLOW_PROMO_SCROLL_ID,
  HEADER_MOB_APP_HEIGHT_OFFSET,
} from 'store/ProductDetails/common/constants';
import { scrollAnimate } from 'utils/scroll';
import { HEADER_HEIGHT } from 'store/common/header/constants';

import { SCROLL_BUNDLE_GUTTER } from './constants';

export const onLookBundle = () => (_, getState) => {
  const state = getState();
  const isMobile = isScreenBelow1004(state);
  const headerHeightComputed = HEADER_HEIGHT;

  // в мобильной версии появляется другой хедер при доскролле -> учитываем его
  const gutter =
    isMobile ? HEADER_MOB_APP_HEIGHT_OFFSET + SCROLL_BUNDLE_GUTTER : SCROLL_BUNDLE_GUTTER;
  const scrollOffset = headerHeightComputed + gutter;

  const node = document.getElementById(FOLLOW_PROMO_SCROLL_ID);
  if (node) {
    scrollAnimate(node, () => {}, scrollOffset);
  }
};
